// External Dependencies:
import axios from 'axios'
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom'

export function setSiteLoaded() {
	return {
		type: 'SET_SITE_LOADED'
	}
}

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		payload: value
	}
}

export function getScreenSize() {
	return {
		type: 'GET_SCREEN_SIZE'
	}
}

export function setOnLineStatus( value ) {
	return {
		type: 'SET_ONLINE_STATUS',
		payload: value
	}
}

export function setConnectionStatus( value ) {
	return {
		type: 'SET_CONNECTION_STATUS',
		payload: value
	}
}

export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function setMenuOpenState( payload ) {
	return {
		type: 'SET_MENU_OPEN_STATE',
		payload
	}
}

export function getSiteData( locale = false ) {
	return function( dispatch, getState ) {
		if ( ! locale ) {
			locale = getState().site.locale
		}

		doRequest( `${dkhSiteData.api_base_url}site-data/?locale=${locale}&v=${dkhSiteData.version}` )
			.then( json => {
				dispatch( receiveSiteData( json ) )
			})
			.catch( error => {

			})
	}
}

export function receiveSiteData( data ) {
	return {
		type: 'RECEIVE_SITE_DATA',
		payload: data
	}
}

export function requestMenuData() {
	return {
		type: 'REQUEST_MENU_DATA'
	}
}

export function getMenuData( username, password ) {
	return function( dispatch, getState ) {
		const { isLoadingMenu } = getState().site

		// Don't load the same thing simultaneously:
		if ( isLoadingMenu ) {
			return
		}

		dispatch( requestMenuData() )

		const { locale } = getState().site

		return doRequest( dkhSiteData.api_base_url + 'menu/?locale=' + locale + '&v=' + dkhSiteData.version )
			.then( json => {
				dispatch( receiveMenuData( json ) )
			})
			.catch( error => {

			})
	}
}

export function receiveMenuData( data ) {
	return {
		type: 'RECEIVE_MENU_DATA',
		payload: data
	}
}




// WEBPACK FOOTER //
// ./redux/actions/site.jsx